export default __webpack_public_path__ + "static/Stash-4f0acf188738062097a91cf3010b9951.woff2";